import { useSelector } from 'react-redux';
import { ACLQueryModeTypes } from 'js/constants/visibilityFilters';

type AppRepository = {
  listing: {
    selectedCardId: number;
    layout: string;
    currentPage: number;
    totalPages: number;
    totalItems: number;
    sortCriteria: string;
    aclQueryMode: string;
  };
  activeViews: {
    activeViews: string[];
  };
  visibilityFilters: {
    filters: object;
    availableFilters: object;
    resourceSuggestions: object;
  };
  contextualSupport: {
    supportPageKeys: string[];
    visible: boolean;
  };
  accessControl: {
    mode: string;
  };
};

function useAppRepository(): AppRepository {
  return useSelector((s: any) => s.app);
}

function useAccessControl() {
  const { mode } = useAppRepository().accessControl;
  return {
    mode,
    isOwner: mode !== ACLQueryModeTypes.MODE_COLLABORATOR.key,
  };
}

export { useAppRepository, useAccessControl };
